import React from "react";

import { ContainerSizeSubBlock as Value } from "@reactivated";

import { withDefaultProps } from "../../utils/react";
import { getStyleVariantClass } from "../../utils/styles";
import { InvertOptional } from "../../utils/types";

import styles from "./index.module.scss";

export interface Props {
    /**
     * Streamfield Block value
     */
    value?: Value | null;

    /** Child components */
    children?: React.ReactNode;
}

const _defaults = {
    value: {
        width: "full",
    },
    children: null,
} as const satisfies InvertOptional<Props>;

export const ContainerSizeSubBlock = withDefaultProps<Props>(
    _defaults,
    (props) => {
        const width = props.value ? props.value.width : _defaults.value.width;
        return (
            <div className={styles.container}>
                <div
                    className={getStyleVariantClass(
                        styles,
                        width ? `width-${width}` : null,
                    )}
                >
                    {props.children}
                </div>
            </div>
        );
    },
);
